// Shared building blocks for the Settings page — extracted from Settings.jsx so
// each subsection (Booking / Integrations / Sequences) can be lazy-friendly and
// hot-reload fast without dragging the 2k-line file with it.

export function Section({ title, subtitle, icon, children }) {
  return (
    <div className="mb-8 border border-zinc-200 bg-white">
      <div className="px-5 py-4 border-b border-zinc-200 flex items-start gap-3">
        <div className="w-8 h-8 bg-[#002FA7] text-white flex items-center justify-center shrink-0 mt-0.5">
          {icon}
        </div>
        <div>
          <h2 className="font-heading text-lg font-bold">{title}</h2>
          {subtitle && <div className="text-xs text-zinc-500 mt-1 max-w-2xl">{subtitle}</div>}
        </div>
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className="overline block mb-2">{label}</label>
      {children}
      {hint ? <div className="text-[11px] text-zinc-500 mt-1.5">{hint}</div> : null}
    </div>
  );
}
